import Rails from '@rails/ujs'
import { doneBProgressBar, startBProgressBar } from '../extensions/progress_bar'
Rails.formSubmitSelector = Rails.formSubmitSelector
  .split(',')
  .map((selector) => `${selector}:not(:is(.themed-content-root *))`)
  .join(',')
window.Rails = Rails
Rails.start()

if (window.BProgress) {
  document.addEventListener('ajax:send', (e) => {
    if (e.target) {
      startBProgressBar()
      e.target.addEventListener('ajax:complete', () => doneBProgressBar())
    }
  })
}
